import React from "react";
import classnames from "classnames";

type Props = {
  dollars: string | number;
  cents: string | number;
  size?: "hero" | "large";
  symbol?: string;
};

export default function BigPrice({
  dollars,
  cents,
  size = "hero",
  symbol = "$",
}: Props) {
  cents = String(Number(cents)).padStart(2, "0");

  return (
    <div className="font-bold whitespace-nowrap">
      <span
        className={classnames("inline-block align-top", {
          "mt-[2px] text-[15px]": size === "large",
          "mt-[5px] text-sm": size === "hero",
        })}
      >
        {symbol}
      </span>
      <span
        className={classnames({
          "text-hero": size === "hero",
          "text-lg": size === "large",
        })}
      >
        {dollars}
      </span>
      <span
        className={classnames("ml-[1px] inline-block align-top", {
          "mt-[2px] text-[15px]": size === "large",
          "mt-[5px] text-sm": size === "hero",
        })}
      >
        <span className="-ml-xs opacity-0">.</span>
        {cents}
      </span>
    </div>
  );
}
